<template>
  <div class="cf-page-container">
    <div class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-16">
      <h1 class="cf-title cf-title--1">
        {{ userNameTitleMessage }}
      </h1>

      <cf-tabbed-routes
        include-route-query-params
        :invalid-redirect-route="{
          name: 'orderMenu',
          params: {
            merchantId: $route.params.merchantId
          }
        }"
        :tabs="[
          {
            isValid: showScanToPayTab,
            label: tabHeaderContent.scanAndPay,
            route: {
              name: 'scanToPay',
            },
            params: {
              merchantId: $route.params.merchantId,
            },
            query: {
              offerAllocationPublicId: $route.query.offerAllocationPublicId,
              thresholdPublicId: $route.query.thresholdPublicId
            }
          },
          {
            isValid: true,
            label: tabHeaderContent.scanOnly,
            route: {
              name: 'scanOnly',
            },
            params: {
              merchantId: $route.params.merchantId
            },
            query: {
              offerAllocationPublicId: $route.query.offerAllocationPublicId,
              thresholdPublicId: $route.query.thresholdPublicId
            }
          }
        ]"
      />

      <router-view />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfTabbedRoutes from '@/view/components/shared/cf-tabbed-routes/index.vue';


  export default {
    name: 'ScanAndPayPage',

    components: {
      CfTabbedRoutes
    },

    metaInfo() {
      return {
        title: 'Single Scan Barcode'
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('giftCards', ['giftCardManagementEnabled']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('savedCards', ['creditCardManagementEnabled']),
      ...mapGetters('session', ['currentUser']),

      userNameTitleMessage() {
        return `Hello ${this.currentUser.fullName}`;
      },

      tabHeaderContent() {
        const { SingleScanHeaders } = this.content;

        return {
          scanAndPay: SingleScanHeaders.metadata?.scanAndPayHeader?.trim(),
          scanOnly: SingleScanHeaders.metadata?.scanOnlyHeader?.trim()
        };
      },

      scanAndPayDisabled() {
        return this.merchant.features['disable-scan-and-pay'];
      },

      showScanToPayTab() {
        return !this.scanAndPayDisabled
          && (this.giftCardManagementEnabled || this.creditCardManagementEnabled);
      }
    },

    async mounted() {
      if (this.giftCardManagementEnabled || this.creditCardManagementEnabled) await this.$realTimeOrdersDatabase.init();
    }
  };
</script>
